import { apiSlice } from "../api/apiSlice";

export const analysesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAnalysis: builder.query({
      query: ({ id }) => `/analyses/${id}`,
      providesTags: (result, error, arg) => [{ type: "Analysis", id: arg?.id }],
    }),
    postAnalyses: builder.mutation({
      query: ({ body }) => {
        return {
          url: `/analyses`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "Analysis" }],
    }),
    patchAnalysisFeatures: builder.mutation({
      query: ({ params, body }) => {
        return {
          url: `/analyses/${params?.analysisId}/features`,
          method: "PATCH",
          body,
        };
      },
      invalidatesTags: (result, error, arg) => [
        { type: "Analysis" },
        { type: "Analysis", id: arg?.params?.analysisId },
      ],
    }),
    patchAnalysisConclusions: builder.mutation({
      query: ({ params, body }) => {
        return {
          url: `/analyses/${params?.analysisId}/conclusions`,
          method: "PATCH",
          body,
        };
      },
      invalidatesTags: (result, error, arg) => [
        { type: "Analysis" },
        { type: "Analysis", id: arg?.params?.analysisId },
      ],
    }),
  }),
});

export const {
  useGetAnalysisQuery,
  usePostAnalysesMutation,
  usePatchAnalysisFeaturesMutation,
  usePatchAnalysisConclusionsMutation,
} = analysesSlice;
